module.exports = __webpack_public_path__ + "img/nav-04.5d3f62dd.jpg";